import Vue from 'vue'
import { EventBus } from '@/router/bus'
import i18n from '@/i18n'
// import FileSaver from 'file-saver'
// import { setTabsInfo, getTabsInfo } from '@/utils/cookie'

Vue.mixin({
  methods: {
    documentationPath () {
      const url = Vue.$config.help_root
      var lastChar = url.substr(url.length - 1)
      if (lastChar !== '/') {
        return url + '/'
      }
      return url
    },
    browserIE11 () {
      return false || !!document.documentMode
    },
    browserFirefox () {
      return typeof InstallTrigger !== 'undefined'
    },
    helpLink (linkRoute) {
      return (Vue.$config.help_root + '/' + linkRoute).replace(/([^:]\/)\/+/g, '$1')
    },
    notifyError (errorMessage) {
      EventBus.$emit('alert', {
        variant: 'error',
        message: errorMessage
      })
    },
    ToCamelCase (word) {
      return word[0].toLowerCase() + word.substring(1)
    },
    shallowCopy (src) {
      return JSON.parse(JSON.stringify(src))
    },
    isProductionEnvironment () {
      return process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase()
    },
    sendLongRunningGetRequest (endpoint, body, formatResponseFunc, setLoaderValueFunc = () => {}) {
      setLoaderValueFunc(true)
      this.$http.get(endpoint, { params: body }).then(
        response => {
          const operationLocation = response.data.payload.operationLocation
          setTimeout(this.getOperationResponse(operationLocation, formatResponseFunc, setLoaderValueFunc), Vue.$config.milliseconds_between_lro_calls)
        },
        error => {
          this.formatErrorResponse(error)
          setLoaderValueFunc(false)
        }
      )
    },
    sendLongRunningPostRequest (endpoint, body, formatResponseFunc, setLoaderValueFunc = () => {}) {
      setLoaderValueFunc(true)
      this.$http.post(endpoint, body).then(
        response => {
          const operationLocation = response.data.payload.operationLocation
          setTimeout(this.getOperationResponse, Vue.$config.milliseconds_between_lro_calls, operationLocation, formatResponseFunc, setLoaderValueFunc)
        },
        error => {
          this.formatErrorResponse(error)
          setLoaderValueFunc(false)
        }
      )
    },
    getOperationResponse (operationLocation, formatResponseFunc, setLoaderValueFunc) {
      let retry = 0
      this.$http.get(operationLocation).then(
        response => {
          formatResponseFunc(response)
          setLoaderValueFunc(false)
        },
        error => {
          if (++retry < Vue.$config.max_lro_retry && error.body.status.code === 8006) {
            setTimeout(this.getOperationResponse, Vue.$config.milliseconds_between_lro_calls, operationLocation, formatResponseFunc, setLoaderValueFunc)
            return
          }
          this.formatErrorResponse(error)
          setLoaderValueFunc(false)
        }
      )
    },
    formatDate (date, displaySeconds) {
      if (displaySeconds === undefined) displaySeconds = true
      const formattedDate = new Date(date)
      var options = { year: 'numeric', month: 'numeric', day: 'numeric' }
      if (displaySeconds) {
        var timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' }
      } else {
        timeOptions = { hour: '2-digit', minute: '2-digit' }
      }

      return formattedDate.toLocaleDateString(Vue.$config.date_locale, options) + ' ' + formattedDate.toLocaleTimeString(Vue.$config.date_locale, timeOptions)
    },
    formatShortDate (date) {
      const formattedDate = new Date(date)
      var options = { year: 'numeric', month: 'numeric', day: 'numeric' }
      return formattedDate.toLocaleDateString(Vue.$config.date_locale, options)
    },
    formatAmount (amount, decimal) {
      if (!amount || isNaN(amount)) amount = 0
      if (isNaN(decimal)) decimal = 2
      const val = (amount / 1).toFixed(decimal).replaceAll('.', ',')
      if (val === 'Infinity') return ''
      var formattedValue = val.toString().replace(/\B(?!\\,\d*)(?=(\d{3})+(?!\d))/g, '.')
      if (!formattedValue.includes(',')) return formattedValue
      var splitedAmount = formattedValue.split(',')
      return splitedAmount[0].concat(',', splitedAmount[1].replaceAll('.', ''))
    },
    formatRevereseAmount (amount) {
      if (!amount || amount === 0) amount = '0,0'
      var splitedAmount = amount.split(',')
      return splitedAmount[0].replaceAll('.', ',').concat('.', splitedAmount[1])
    },
    formatLongInteger (amount) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatNumber (amount) {
      return Number(amount?.toString().replaceAll('.', '').replaceAll(',', '.'))
    },
    sum (items) {
      let totalValue = 0
      for (var j = 0; j < items.length; j++) {
        var itemValue = Number(items[j]?.toString().replaceAll('.', '').replaceAll(',', '.'))
        totalValue += itemValue
      }
      return totalValue
    },
    sumReal (items) {
      let totalValue = 0
      for (var j = 0; j < items.length; j++) {
        var itemValue = Number(items[j])
        totalValue += itemValue
      }
      return totalValue
    },
    formatDocumentSize (size) {
      if (size < 1024) return this.formatAmount(size, 0) + ' bytes'
      var kb = size / 1024
      if (kb < 1024) return this.formatAmount(kb, 0) + ' KB'
      var mb = kb / 1024
      return this.formatAmount(mb, 0) + ' MB'
    },
    formatDocumentErrorResponse (error, limitError) {
      const apiErrorLink = Vue.$config.help_root + Vue.$apiConfig.apiCodes
      let errorMessage = ''
      let errorLink = ''
      const multipleErrors = []
      if (error.status === 422) {
        const response = JSON.parse(error.response)
        for (let i = 0; i < response.errors.length; i++) {
          const messageItem = {}
          const errorPayload = response.errors[i].message
          if (errorPayload.indexOf('.') > -1) {
            const fluentErrors = errorPayload.split('.')
            for (let z = 0; z < fluentErrors.length; z++) {
              if (fluentErrors[z]) {
                messageItem.msg = `${i18n.t('apiStatusCodes.' + fluentErrors[z])}`
                multipleErrors.push(messageItem)
              }
            }
          } else {
            messageItem.msg = `${i18n.t('apiStatusCodes.' + errorPayload)}`
            multipleErrors.push(messageItem)
          }
        }
      } else {
        const response = JSON.parse(error.response)
        if (response && response.status && response.status.code) {
          errorMessage = i18n.t('apiStatusCodes.' + response.status.code)
          errorLink = apiErrorLink + response.status.code
          if (response.status.code === 'InvalidProjectFormValues' && response.additionalInformation !== 'undefined' && response.additionalInformation !== null) {
            const errors = response.additionalInformation.errors
            for (let i = 0; i < errors.length; i++) {
              const messageItem = {}
              if (errors[i]) {
                const indexMsg = errors[i].index !== 0 ? '. (' + `${i18n.t('apiStatusCodes.row')}` + ': ' + errors[i].index + ')' : ''
                messageItem.msg = `${i18n.t('apiStatusCodes.' + errors[i].statusCode.code)}` + indexMsg
                multipleErrors.push(messageItem)
              }
            }
            errorLink = apiErrorLink + response.status.code
          }
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          errorLink = apiErrorLink + error.status
        }
      }
      EventBus.$emit('alert', {
        variant: 'error',
        message: errorMessage,
        link: errorLink,
        errors: multipleErrors
      })
    },
    formatErrorResponse (error, limitError) {
      const apiErrorLink = Vue.$config.help_root + Vue.$apiConfig.apiCodes
      let errorMessage = ''
      let errorLink = ''
      const multipleErrors = []
      if (error.status === 422) {
        for (let i = 0; i < error.data.errors.length; i++) {
          const messageItem = {}
          const errorPayload = error.data.errors[i].message
          if (errorPayload.indexOf('.') > -1) {
            const fluentErrors = errorPayload.split('.')
            for (let z = 0; z < fluentErrors.length; z++) {
              if (fluentErrors[z]) {
                messageItem.msg = `${i18n.t('apiStatusCodes.' + fluentErrors[z])}`
                multipleErrors.push(messageItem)
              }
            }
          } else {
            messageItem.msg = `${i18n.t('apiStatusCodes.' + errorPayload)}`
            multipleErrors.push(messageItem)
          }
        }
      } else if (error.status === 429) {
        if (limitError && limitError.length > 0) {
          errorMessage = i18n.t(limitError)
          errorLink = apiErrorLink + error.status
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          errorLink = apiErrorLink + error.status
        }
      } else {
        if (error.data && error.data.status && error.data.status.code) {
          errorMessage = i18n.t('apiStatusCodes.' + error.data.status.code)
          errorLink = apiErrorLink + error.data.status.code
          if (error.data.status.code === 'InvalidProjectFormValues' && error.data.additionalInformation !== 'undefined' && error.data.additionalInformation !== null) {
            const errors = error.data.additionalInformation.errors
            for (let i = 0; i < errors.length; i++) {
              const messageItem = {}
              if (errors[i]) {
                const indexMsg = errors[i].index !== 0 ? '. (' + `${i18n.t('apiStatusCodes.row')}` + ': ' + errors[i].index + ')' : ''
                messageItem.msg = `${i18n.t('apiStatusCodes.' + errors[i].statusCode.code)}` + indexMsg
                multipleErrors.push(messageItem)
              }
            }
            errorLink = apiErrorLink + error.data.status.code
          }
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          errorLink = apiErrorLink + error.status
        }
      }
      EventBus.$emit('alert', {
        variant: 'error',
        message: errorMessage,
        link: errorLink,
        errors: multipleErrors
      })
    },
    formatSuccessErrorsResponse (error, limitError) {
      const errorMessage = i18n.t('apiStatusCodes.' + error.code)
      const multipleErrors = []
      const errorPayload = error.message
      let messageItem = {}
      if (errorPayload.indexOf('.') > -1) {
        const fluentErrors = errorPayload.split('.')
        for (let z = 0; z < fluentErrors.length; z++) {
          if (fluentErrors[z]) {
            messageItem = {}
            messageItem.msg = `${i18n.t('apiStatusCodes.' + fluentErrors[z])}`
            multipleErrors.push(messageItem)
          }
        }
      } else {
        messageItem.msg = `${i18n.t('apiStatusCodes.' + errorPayload)}`
        multipleErrors.push(messageItem)
      }

      EventBus.$emit('alert', {
        variant: 'error',
        message: errorMessage,
        errors: multipleErrors
      })
    },
    toBoldLatin (word) {
      var answer = ''
      var a = {}

      a['А'] = 'a'; a['а'] = 'a'
      a['Б'] = 'b'; a['б'] = 'b'
      a['В'] = 'v'; a['в'] = 'v'
      a['Г'] = 'g'; a['г'] = 'g'
      a['Д'] = 'd'; a['д'] = 'd'
      a['Ђ'] = 'dj'; a['ђ'] = 'dj'
      a['Е'] = 'e'; a['е'] = 'e'
      a['Ж'] = 'z'; a['ж'] = 'z'
      a['З'] = 'z'; a['з'] = 'z'
      a['И'] = 'i'; a['и'] = 'i'
      a['Ј'] = 'j'; a['ј'] = 'j'
      a['К'] = 'k'; a['к'] = 'k'
      a['Л'] = 'l'; a['л'] = 'l'
      a['Љ'] = 'lj'; a['љ'] = 'lj'
      a['М'] = 'm'; a['м'] = 'm'
      a['Н'] = 'n'; a['н'] = 'n'
      a['Њ'] = 'nj'; a['њ'] = 'nj'
      a['О'] = 'o'; a['о'] = 'o'
      a['П'] = 'p'; a['п'] = 'p'
      a['Р'] = 'r'; a['р'] = 'r'
      a['С'] = 's'; a['с'] = 's'
      a['Т'] = 't'; a['т'] = 't'
      a['Ћ'] = 'c'; a['ћ'] = 'c'
      a['У'] = 'u'; a['у'] = 'u'
      a['Ф'] = 'f'; a['ф'] = 'f'
      a['Х'] = 'h'; a['х'] = 'h'
      a['Ц'] = 'c'; a['ц'] = 'c'
      a['Ч'] = 'c'; a['ч'] = 'c'
      a['Џ'] = 'dz'; a['џ'] = 'dz'
      a['Ш'] = 's'; a['ш'] = 's'
      a['Č'] = 'c'; a['č'] = 'c'
      a['Ć'] = 'c'; a['ć'] = 'c'
      a['Š'] = 's'; a['š'] = 's'
      a['Đ'] = 'dj'; a['đ'] = 'dj'
      a['Ž'] = 'z'; a['ž'] = 'z'

      for (const i in word) {
        if (Object.prototype.hasOwnProperty.call(word, i)) {
          if (a[word[i]] === undefined) {
            var letters = /^[0-9a-zA-Z ]+$/
            if (word[i].match(letters)) {
              answer += word[i]
            }
          } else {
            answer += a[word[i]]
          }
        }
      }
      return answer
    },
    deepEqual (object1, object2) {
      const keys1 = Object.keys(object1)
      const keys2 = Object.keys(object2)
      if (keys1.length !== keys2.length) {
        return false
      }
      for (const key of keys1) {
        const val1 = object1[key]
        const val2 = object2[key]
        const areObjects = this.isObject(val1) && this.isObject(val2)
        if ((areObjects && !this.deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
          return false
        }
      }
      return true
    },
    isObject (object) {
      return object != null && typeof object === 'object'
    }
  }
})
